var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7260",
    "data-name": "Group 7260",
    transform: "translate(-404.5 -972.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(405 973)",
    fill: "#fff",
    stroke: "#40aeba",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "phone-svgrepo-com",
    d: "M9.256,18.261C1.081,10.085,2.243,6.341,3.105,5.135c.111-.2,2.84-4.28,5.765-1.883,7.261,5.98-1.629,5.767,4.166,11.232s5.253-3.095,11.231,4.164c2.4,2.926-1.688,5.655-1.882,5.765C21.178,25.275,17.432,26.438,9.256,18.261Z",
    transform: "translate(417 985)",
    fill: "none",
    stroke: "#40aeba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.2b6d3ccb707e8ae37c6d90d575bd682d.svg";
export { ForwardRef as ReactComponent };